'use client';

import {
  MobileHomeTemplate,
  WebHomeTemplate
} from 'components/atomic/template';
import { useIsMobile } from 'helpers/screenResolutionHelper';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

export default function HomeClient({
  blogPost,
  collections,
  parentCategories
}) {
  const [isMobileView] = useIsMobile();
  const [parentCategoriesData, setParentCategoriesData] = useState([]);
  const t = useTranslations('homeBanner');

  useEffect(() => {
    if (parentCategories?.length) {
      setParentCategoriesData(parentCategories);
    }
  }, [parentCategories]);

  const Component = isMobileView ? MobileHomeTemplate : WebHomeTemplate;

  return (
    <Component
      blogPost={blogPost}
      collections={collections}
      parentCategories={parentCategoriesData}
      bannerTranslation={{ t, ready: true }}
    />
  );
}
